<template>
  <div class="main-container">
    <Navbar :home="false" />
    <div class="section-wrapper">
      <SectionTitle title="Projects" />
      <div class="section-content">
        <Project
          v-for="(item, i) in media"
          v-scroll-reveal.reset="
            i % 2 === 0 ? vScrollOpts.right : vScrollOpts.left
          "
          :key="item.key"
          :index="i + 1"
          :projectData="item"
        />
        <Project
          v-scroll-reveal.reset="vScrollOpts.left"
          :projectData="ticTacToe"
          :embed="true"
        >
          <TicTacToe />
        </Project>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import SectionTitle from '@/commonComponents/SectionTitle'
  import Project from '@/components/Projects/Project'
  import Footer from '@/components/Footer'
  import TicTacToe from '@/components/Projects/TicTacToe.vue'

  import {
    chickenMeetsWorm,
    travelog,
    pixilz,
    birds,
    gridsomeSnippet,
    ticTacToe
  } from '@/components/Projects/projectsData'
  import { mapState } from 'vuex'

  export default {
    name: 'Projects',
    components: {
      SectionTitle,
      Navbar,
      Project,
      Footer,
      TicTacToe
    },
    data() {
      return {
        ticTacToe: ticTacToe,
        media: [chickenMeetsWorm, travelog, pixilz, birds, gridsomeSnippet]
      }
    },
    computed: {
      ...mapState(['vScrollOpts'])
    },
    methods: {
      openGallery(index) {
        this.$refs.lightbox.showImage(index)
      }
    }
  }
</script>

<style scoped lang="scss">
  @include section;
  .section-content {
    margin: 0 auto;
  }
</style>
